export default __webpack_public_path__ + "static/media/envelop.b656d942.svg";